import * as React from "react";
import { NonInteractivePromptBadge } from "./PromptBadge/PromptBadge";
import { PromptBadgeGroup } from "./PromptBadge/PromptBadgeGroup";
import type { PromptBadgesProps } from "./PromptBadges.types";
export type DisplayMode = "iconOnly" | "textOnly" | "iconAndText";

export const PromptBadges: React.FC<PromptBadgesProps> = ({
  badges,
  maxNumber,
  displayMode,
  tagSize = "small",
  labelWrapper,
}) => {
  const badgesSlice = badges.slice(0, maxNumber);
  const extraBadges = badges.slice(maxNumber);

  return (
    <PromptBadgeGroup extraBadges={extraBadges}>
      {badgesSlice.map((badge) => (
        <NonInteractivePromptBadge
          key={badge.id}
          badge={badge}
          tagSize={tagSize}
          displayMode={displayMode}
          labelWrapper={labelWrapper}
        />
      ))}
    </PromptBadgeGroup>
  );
};
